import { enhancedTmsApiService } from '#api/enhancements/enhancedTmsApiService'
import type { EnhancedMarketId } from '#api/enhancements/enhancedTmsApiTypes'
import type { AdminNatCodesMarket } from '#api/tmsApiService'
import { store } from '#app/store'
import { toastError } from '#features/ErrorHandling/toastError'

type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] }

export type MarketWithNationalCodes = WithRequired<AdminNatCodesMarket, 'groups'>

export async function loadNationalCodes(marketId: EnhancedMarketId): Promise<MarketWithNationalCodes> {
  const request = store.dispatch(enhancedTmsApiService.endpoints.getApiAdmintoolMarketsByMarketId.initiate({ marketId, recursive: true }))
  const result = await request.unwrap()

  if (!result.market) {
    throw new Error(`Market with ID ${marketId} not found`)
  }

  if (!result.market.groups) {
    toastError(new Error(`Market with ID ${marketId} has no national codes groups defined`))
    return { ...result.market, groups: [] } as MarketWithNationalCodes
  }

  return result.market as MarketWithNationalCodes
}

export const loadMarketAttributes = async (marketId: EnhancedMarketId) => {
  const request = store.dispatch(enhancedTmsApiService.endpoints.getApiAdmintoolMarketsByMarketIdFactoryCodeAttrs.initiate({ marketId }))
  const result = await request.unwrap()

  if (!result.listOfFactoryCodeAttributes) {
    throw new Error(`Market with ID ${marketId} not found`)
  }
  return result.listOfFactoryCodeAttributes
}

export const loadMarketDetails = async (marketId: EnhancedMarketId) => {
  const nationalCodes = loadNationalCodes(marketId)
  const marketAttributes = loadMarketAttributes(marketId)

  return [await nationalCodes, await marketAttributes] as const
}
